import React, { useState } from "react"
import { message } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import Button from "../MyButton/Button"
import dayjs from "dayjs"

const BtnExportExcel = ({
  api,
  filter = {},
  fileName = "export.xlsx",
  buttonText = "Xuất Excel",
  keyword = undefined,
  params = {}
}) => {
  const [loading, setLoading] = useState(false)

  const handleExportExcel = async () => {
    setLoading(true)
    try {
      const response = await api({ ...params, filter: { ...filter }, keyword })
      if (response) {
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })

        const url = window.URL.createObjectURL(blob)
        const link = document.createElement("a")
        link.href = url
        const dateStr = dayjs().format("YYYY-MM-DD")
        const finalFileName =
          fileName.replace(/\.xlsx$/, "") + `_${dateStr}.xlsx`

        link.setAttribute("download", finalFileName)
        document.body.appendChild(link)
        link.click()

        link.remove()
        window.URL.revokeObjectURL(url)
      } else {
        message.error("Không có dữ liệu để xuất Excel.")
      }
    } catch (error) {
      console.error("Lỗi khi xuất Excel:", error)
      message.error("Xuất Excel thất bại.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      btnType="primary1"
      // icon={<DownloadOutlined />}
      loading={loading}
      onClick={handleExportExcel}
    >
      {buttonText}
    </Button>
  )
}

export default BtnExportExcel
